import { useLocation } from "react-router-dom";
import BannerTable from "components/banners/BannerTable";
import BannerForm from "components/banners/BannerForm";
import Modal from "components/common/Modal";
import { useBanners } from "components/banners/hooks/useBanners";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { flattenBy } from "@tanstack/react-table";


const TYPE_BY_PATH = {
  herolist: "Hero",
  popuplist: "Popup",
  bubblelist: "Bubble",
  flashlist: "Flash"
};

export default function BannerIndex() {
  const location = useLocation();
  const slug = location.pathname.split("/").pop();
  const bannerType = TYPE_BY_PATH[slug];

  const banners = useBanners();
  const [editing, setEditing] = useState(null);

  const userId = "69579c6190a653b640e65639";

  const navigate = useNavigate();

  const LIST_ROUTE_BY_TYPE = {
      Hero: "/admin/banners/herolist",
      Popup: "/admin/banners/popuplist",
      Bubble: "/admin/banners/bubblelist", 
      Flash: "/admin/banners/flashlist", 
    };


  const handleDelete = async (id) => {
    await banners.removeBanner(id, {
      is_deleted: true,
      deleted_by: userId,
    });
    await banners.reload(bannerType);
  };


  useEffect(() => {
    if (bannerType) {
      banners.load(bannerType);
    }
    setEditing(null);
  }, [bannerType]);

  return (
    <>
        {editing ? (
        <div className="rounded-2xl border bg-white p-6">
            <BannerForm
              initialData={editing?._id ? editing : null}
              onSubmit={async (fd) => {
                if (editing?._id) {
                  await banners.editBanner(editing._id, fd);
                } else {
                  await banners.addBanner(fd);
                }

                await banners.reload(bannerType);
                setEditing(null);
                 navigate(LIST_ROUTE_BY_TYPE[bannerType]);
              }}
              
              onClose={() => setEditing(null)}
            />

        </div>
        ) : (
            <BannerTable
            bannerType={bannerType}
            data={banners.data}
            loading={banners.loading}
            onAdd={() =>
            setEditing({ banner_type: bannerType })
            }
            onEdit={setEditing}
            onDelete={handleDelete}
            onReorder={async (payload) => {
              await banners.reorder(payload, bannerType);
              await banners.reload(bannerType);
            }}
        />
        )
        }

    </>
  );
}
